module.exports = __webpack_public_path__ + "static/media/logoFBDG trsprt.18e93703.png";